module.exports = __webpack_public_path__ + "static/media-ratios-e28209bf322c09a2af38e52bbe275f1a.png";